export const numberMustBeBetween = (min, max) => {
  return (props, propName, componentName) => {
    const prop = props[propName]

    if (typeof min !== 'number' && typeof max !== 'number')
      return new Error(
        `Invalid min and max inputs in validation of ${propName} on ${componentName}.`
      )

    const notNumber = typeof prop !== 'number'
    const lessThanMin = typeof min === 'number' && prop < min
    const greaterThanMax = typeof max === 'number' && prop > max

    if (notNumber || lessThanMin || greaterThanMax) {
      let message = `Prop ${propName} must be a number`

      if (lessThanMin && greaterThanMax) message += ` between ${min} and ${max}`
      else if (lessThanMin) message += ` greater than ${min}`
      else if (greaterThanMax) message += ` less than ${max}`
      message += ` on ${componentName}.`

      return new Error(message)
    }
  }
}
